import React from "react"
import { Copy, RefreshCw, GitBranch, Code, Bookmark } from "lucide-react"

interface MessageActionsProps {
  message: any
  onCopy: () => void
  onRegenerate: () => void
  onBranch?: () => void
  onShowRaw?: () => void
  onBookmark?: () => void
}

export const MessageActions: React.FC<MessageActionsProps> = ({
  message,
  onCopy,
  onRegenerate,
  onBranch,
  onShowRaw,
  onBookmark,
}) => {
  return (
    <div className="absolute -top-2 -right-2 opacity-0 group-hover:opacity-100 transition-opacity flex gap-1">
      <button
        onClick={onCopy}
        className="p-1 bg-background border border-border rounded text-xs hover:bg-muted"
        title="Copy message"
      >
        <Copy className="h-3 w-3" />
      </button>

      {message.role === "assistant" && (
        <button
          onClick={onRegenerate}
          className="p-1 bg-background border border-border rounded text-xs hover:bg-muted"
          title="Regenerate response"
        >
          <RefreshCw className="h-3 w-3" />
        </button>
      )}

      {onBranch && (
        <button
          onClick={onBranch}
          className="p-1 bg-background border border-border rounded text-xs hover:bg-muted"
          title="Branch conversation"
        >
          <GitBranch className="h-3 w-3" />
        </button>
      )}

      {onShowRaw && (
        <button
          onClick={onShowRaw}
          className="p-1 bg-background border border-border rounded text-xs hover:bg-muted"
          title="Show raw message"
        >
          <Code className="h-3 w-3" />
        </button>
      )}

      {onBookmark && (
        <button
          onClick={onBookmark}
          className="p-1 bg-background border border-border rounded text-xs hover:bg-muted"
          title="Bookmark message"
        >
          <Bookmark className="h-3 w-3" />
        </button>
      )}
    </div>
  )
}
